const ORDER_DETAILS_ACTIONS = {
  CONFIRM_COD: 'R',
  CANCEL: 'C',
  TRACKING: 'T',
  CHANGE: 'B',
  REJECT: 'D',
};

const ORDER_TYPE = {
  PURCHASE: 'ZTON',
  RETURN: 'ZDVN',
};

const PURCHASE_ORDER_STATUS = {
  EN: 'SENT',
  PC: 'TO BE CONFIRMED',
  CA: 'CANCELLED',
  PE: 'PENDING',
  TR: 'SENT',
  FI: 'DELIVERED',
};

const RETURNS_ORDER_STATUS = {
  FI: 'ACCEPTED',
  PE: 'REGISTERED',
  CA: 'CANCELLED',
  RE: 'RECEIVED',
  EN: 'IN PROCESS',
  NA: 'NOT ACCEPTED',
};

module.exports = {
  ORDER_DETAILS_ACTIONS,
  ORDER_TYPE,
  PURCHASE_ORDER_STATUS,
  RETURNS_ORDER_STATUS,
};
